import { HttpStatusCode, isAxiosError } from "axios";
import { SendToTrackingService } from "@/api/handlers/errors";
import { useApiClient } from "@/hooks/useApiClient";
import useSWRMutation, { type SWRMutationResponse } from "swr/mutation";

/**
 * プロット詳細を削除するカスタムフック
 */
export const useDeletePlotRequestDetails = (): SWRMutationResponse<
  void,
  Error,
  string,
  number[]
> => {
  const { apiClient } = useApiClient();
  const url = "/map/plot-request-details/bulk-delete";

  const fetcher = async (
    url: string,
    { arg }: { arg: number[] }
  ): Promise<void> => {
    try {
      const response = await apiClient.post(url, { id: arg });

      if (
        response.status !== HttpStatusCode.Ok &&
        response.status !== HttpStatusCode.NoContent
      ) {
        throw new Error("削除に失敗しました");
      }
    } catch (error) {
      if (
        isAxiosError(error) &&
        (error.response?.status ?? HttpStatusCode.InternalServerError) >=
          HttpStatusCode.InternalServerError
      ) {
        SendToTrackingService(error);
      }
      throw error;
    }
  };

  return useSWRMutation(url, fetcher, { revalidate: false });
};
